// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kboR9cN9wHfimdgP-FP0YQ\\=\\={border-bottom:1px solid var(--xds-color-divider-default)}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardDeliveryData/DashboardDeliveryData.module.scss"],"names":[],"mappings":"AAAA,4BACI,wDAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DeliveryDashboardDataTabContainer": "kboR9cN9wHfimdgP-FP0YQ=="
};
export default ___CSS_LOADER_EXPORT___;
